export default {
  'bulk-sms': ['all', 'agent', 'member', 'admin', 'committee'],
  'push-notifications': ['all', 'member', 'committee'],
  emails: ['all', 'admin', 'user'],
};
